"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var _useFieldContext = _interopRequireDefault(require("../../../../hooks/useFieldContext"));
var _useFormContext = _interopRequireDefault(require("../../../../hooks/useFormContext"));
var _sprintf = _interopRequireDefault(require("../../../../../../utils/sprintf"));
var _react = require("react");
var _server = require("react-dom/server");
var _uuid = require("uuid");
var _sv = _interopRequireDefault(require("../../../../sv.json"));
var FSTypes = _interopRequireWildcard(require("../../../../types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var validationName = "length";
var Length = function Length(props) {
  var _a, _b;
  var children = props.children,
    exactly = props.exactly,
    i18n = props.i18n,
    min = props.min,
    max = props.max,
    _c = props.type,
    type = _c === void 0 ? FSTypes.ValidationTypes.Error : _c,
    validateOnChange = props.validateOnChange;
  var uuid = (0, _react.useState)((0, _uuid.v4)())[0];
  var formI18n = (0, _useFormContext.default)().i18n;
  var _d = (0, _useFieldContext.default)(),
    addAdditionalInputProp = _d.addAdditionalInputProp,
    addValidation = _d.addValidation,
    label = _d.label,
    removeValidation = _d.removeValidation,
    fieldContextValidateOnChange = _d.validateOnChange;
  (0, _react.useEffect)(function () {
    // check for undefined to allow 0 as well
    if (exactly !== undefined && (min !== undefined || max !== undefined)) {
      console.error("Warning: You provided a `exactly` prop to a FS.Validation.Length while also providing a `min` and/or `max` prop");
    }
  }, [exactly, max, min]);
  (0, _react.useEffect)(function () {
    addAdditionalInputProp("maxLength", exactly || max ? exactly || max : undefined);
    return function () {
      addAdditionalInputProp("maxLength", undefined);
    };
  }, [addAdditionalInputProp, exactly, max]);
  var validation = (0, _react.useCallback)(function (value, fieldName) {
    var _a, _b, _c, _d;
    if (typeof value !== "string" || value.length === 0) {
      return [];
    }
    var textKey;
    if (exactly !== undefined) {
      if (value.length !== exactly) {
        textKey = "exactly";
      }
    } else {
      if (min !== undefined && max !== undefined) {
        if (min === max) {
          if (value.length !== min) {
            textKey = "exactly";
          }
        } else {
          if (value.length < min || value.length > max) {
            textKey = "between";
          }
        }
      } else if (min !== undefined) {
        if (value.length < min) {
          textKey = "min";
        }
      } else if (max !== undefined) {
        if (value.length > max) {
          textKey = "max";
        }
      }
    }
    if (textKey) {
      return [{
        fieldName: fieldName,
        type: type,
        text: children !== undefined ? (0, _server.renderToString)((0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
          children: children
        })) : (0, _sprintf.default)((i18n === null || i18n === void 0 ? void 0 : i18n[textKey]) || ((_c = (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.length) === null || _c === void 0 ? void 0 : _c[textKey]) || ((_d = _sv.default.validation.field.length) === null || _d === void 0 ? void 0 : _d[textKey]), {
          value: String(value),
          fieldName: fieldName,
          label: String(label),
          exactly: exactly === undefined && min === max ? String(min) : String(exactly),
          max: String(max),
          min: String(min)
        })
      }];
    }
    return [];
  }, [children, exactly, (_b = (_a = formI18n === null || formI18n === void 0 ? void 0 : formI18n.validations) === null || _a === void 0 ? void 0 : _a.field) === null || _b === void 0 ? void 0 : _b.length, i18n, label, max, min, type]);
  (0, _react.useEffect)(function () {
    addValidation("".concat(validationName, "_").concat(uuid), validation, validateOnChange || fieldContextValidateOnChange);
    return function () {
      removeValidation("".concat(validationName, "_").concat(uuid));
    };
  }, [addValidation, fieldContextValidateOnChange, removeValidation, uuid, validateOnChange, validation]);
  return null;
};
var _default = Length;
exports.default = _default;